import { composeInitialState } from '@opengov/compose-app';

import { composeStateMachine } from '../module';

export const modalInitialState = composeInitialState({
  componentType: ''
});

export const modalState = composeStateMachine('MODAL', modalInitialState, compose => ({
  setModalComponentType: compose.action((state, componentType: string) => state.set('componentType', componentType)),

  resetModalState: compose.payloadlessAction(state => state.set('componentType', ''))
}));

export const {
  actions: modalActions,
  actionCreators: modalActionCreators,
  reducer: modalReducer,
  selector: modalSelector
} = modalState;
